export default "__VITE_ASSET__cf39f0b7__"